<template>
  <el-dialog
    append-to-body
    title="选择协议版本"
    width="278px"
    @close="handleCancle"
    @closed="reset"
    :visible="visible"
  >
    <el-radio-group v-model="choosedVersion" class="version-group">
      <el-row class="version-item" v-for="item in versionList" :key="item.id">
        <el-radio :label="item.id">{{ item.protocolVersion }}</el-radio>
      </el-row>
    </el-radio-group>
    <el-row type="flex" justify="end">
      <el-button style="margin-right: 16px" @click="handleCancle">取消</el-button>
      <el-button type="primary" @click="handleOk">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import dealApi from 'api/home/deal-mangement';
export default {
  props: {
    versionList: {
      default: () => []
    }
  },
  data() {
    return {
      id: '',
      choosedVersion: '',
      visible: false
    };
  },
  methods: {
    init(id) {
      this.id = id;
      this.visible = true;
    },
    reset() {
      this.choosedVersion = '';
      this.id = '';
    },
    handleCancle() {
      this.visible = false;
    },
    async handleOk() {
      const {
        data: { data, code }
      } = await this.getGoodServerByVersionId();
      if (data.protocolVersionServerPortResultList.length === 0) {
        this.$message.warning('暂无法选择该协议版本');
        return;
      }
      const obj = {
        id: this.getVersion().id,
        name: this.getVersion().protocolVersion,
        serverPortId: data.protocolVersionServerPortResultList[0].id
      };
      this.$emit('back', true, { id: this.id, version: obj });
      this.visible = false;
    },
    getVersion() {
      return this.versionList.find(item => {
        return item.id == this.choosedVersion;
      });
    },
    getGoodServerByVersionId() {
      return dealApi.getGoodServerAndPortByVersionId({
        protocolVersionId: this.choosedVersion
      });
    }
  }
};
</script>
<style lang="less" scoped>
.version-group {
  width: 100%;
  margin-bottom: 16px;
  .version-item {
    padding-left: 28px;
    margin-bottom: 16px;
    /deep/.el-radio {
      display: flex;
      align-items: flex-start;
    }
    /deep/ .el-radio__label {
      white-space: pre-wrap;
      display: inline-block;
    }
  }
}
</style>